import React, { useState, useCallback, useEffect, useRef } from "react";
import httpClient from "../../api/module/httpClient"
import { homeSelector } from "redux/selectors/homeSelector";
import { connect } from "react-redux";
import { getUser } from "redux/actions/home-actions";
import { useLocation } from "react-router-dom";
import { notification, Skeleton } from "antd"
import { ModalCompleteYourProfile, CustomButton } from "components";
import { useHistory } from "react-router-dom";
import ModalEditInfo from "./ModalEditInfo";
import { INTERNAL_LINKS } from "enum";
// import { useParams } from 'react-router-dom';
import VideoPlayer from 'images/video-player.js'
import Certificate from "../VerifyCertificate/CertificateOnDemandPrograms/certificate"
import Card from "./Card/index"
import IconBack from "images/icon-back.svg";

import "./style.scss";

const OnDemandCertificateprograms = ({userProfile,getUser,match}) => {

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [courses, setCourses] = useState([])
  const [tab, setTab] = useState(1);
  const [bulCompleteProfile, setBulCompleteProfile] = useState(false);
  const [diploma, setDiploma] = useState(null)
  const clock = useRef(null);
  const [dataPage, setDataPage] = useState(false);
  const [dataSelected, setDataSelected] = useState({});
  const { search } = useLocation();  
  const history = useHistory();

  const query = new URLSearchParams(search);
  const [visible, setVisible] = useState({});
  const id = query?.get("id");
  const slug = query?.get("code");
  const update = query?.get("update");
  const {url} = match

  
  useEffect(() => {
    const parts = url.split("/");  
    const slugg = parts[parts.length - 1];
    let courseFind = courses?.find(e => e?.id === slugg);
    if(courseFind && !dataPage){
      setDataPage(courseFind);
    }
  }, [url,courses]);
  
  useEffect(() => {
    if (update === "true" || update === true) {
      setDataPage(false)
      history.push(INTERNAL_LINKS.ON_DEMAND_CERTIFICATEPROGRAMS);
    }
  }, [update, history]);

  const getUrlLearnWorlds = useCallback(async () => {
    setLoading(true)
    if(clock.current){ clearTimeout(clock.current); };
    clock.current = setTimeout(async () => {
      try {
        const response = await httpClient.get("private/getOnDemandCourses");

        setCourses(response?.data?.ondemand);
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
        notification.error({ message: "Error", description: "Try again." });
      }
    }, 100);
  },[userProfile])

  useEffect(() => {
    if(userProfile?.firstName){
      getUrlLearnWorlds();
    }
  },[userProfile])

  const clickCardOnDemand = async (data) => {
    try{

      if (userProfile.memberShip !== "premium") {
        return notification.error({ message: "You must be a premium user." });
      }

      if ( !userProfile?.completed || userProfile?.percentOfCompletion !== 100) {
        return setBulCompleteProfile(true);
      }
      
      const response = await httpClient.post("private/enrollOnDemandCourses",{
        ...data,
        timeCertificate: data?.onDemand?.timeCertificate
      });

      if(response?.data?.bulEnroll){ 
        setCourses(courses.map(e => ({...e, enroll: e?.id === data?.id ? true : e?.enroll}))) 
        notification.success({
          message: "Enrolled",
        });
      }

      window.open(response?.data?.url, "_blank");
      setDataPage(false)
      history.push(INTERNAL_LINKS.ON_DEMAND_CERTIFICATEPROGRAMS);

    }catch(er) {
      console.log(er);
    }
  }

  const clickCardOnDemandPage = async (data) => {
    setDataPage(data);
    history.push(`${INTERNAL_LINKS.ON_DEMAND_CERTIFICATEPROGRAMS}/${data?.id}`);    
    return
  }

  const getCertificationOnDemandCertificate = useCallback(async () => {
    setLoading2(true)
    if(clock.current){ clearTimeout(clock.current); };
    clock.current = setTimeout(async () => {
      try {
        const response = await httpClient.get(`private/getCertification?id=${id}&slug=${slug}`);

        if(response?.data?.status !== 'completed'){
          notification.error({ message: "Error", description: "Complete the certificate to unlock the content." });
        }else{
          setDiploma(response?.data);
        }
        setLoading2(false)
      } catch (error) {
          console.log(error)
          setLoading2(false)
          notification.error({ message: "Error", description: "Try again." });
      }
    }, 100);
  },[slug,id])
  
  const openModalContent = async (data) => {
    setDataSelected(data);
    visible.modal(true);
    if(data?.onDemand){
      visible.set(data?.onDemand)
    }
  }

  useEffect(() => {
    if(slug && id){
      getCertificationOnDemandCertificate()
    }else{
      setDiploma(null);
    }
  },[slug,id])

  const filterSpecial = (data) => {
    return userProfile?.email === 'morecontrol64@gmail.com' ? data : data?.filter(e => e?.id !== "test-course")
  }

  const loadingContent = <div style={{display:'flex',flexDirection:'column',marginTop:'40px'}}>
    <Skeleton style={{width:'100%',height:'150px'}} active />
    <Skeleton style={{width:'100%',height:'150px'}} active />
    <Skeleton style={{width:'100%',height:'150px'}} active />
  </div>

  return (<div className="reference-ondemand">
    {!loading2 && !diploma ? <>
      <div className="container-relative-ondemand">
      <h1 className="main-title-section-on" style={{display:'flex',flexDirection:'row',flexWrap:'nowrap', gap:'10px', paddingLeft:'20px'}}>
        <VideoPlayer color={'black'} /> {dataPage?.title || 'On-Demand Certificate Programs'}
      </h1>
        <div className="container-ondemand" style={!dataPage ? {opacity:'1', zIndex:'2'} : {opacity:'0', zIndex:'1'}}>
          <div className="container-one">
            <div className="container-two">
              <div className="container-tabs-tabsondemand">
                <div className={ tab === 1 ? "title-list-ondemand" : "title-list-ondemand2"}
                  onClick={() => {setTab(1)}}
                >On-Demand Certificate Programs Available</div>
                {filterSpecial(courses || [])?.filter(co => !!co?.enroll && !co?.finish ).length > 0 &&<div className={ tab === 2 ? "title-list-ondemand" : "title-list-ondemand2"}
                  onClick={() => setTab(2)}
                >My On-Demand Certificate Programs</div>}
                {filterSpecial(courses || [])?.filter(co => !!co?.finish ).length > 0 && <div className={ tab === 3 ? "title-list-ondemand" : "title-list-ondemand2"}
                  onClick={() => setTab(3)}
                >Past On-Demand Certificate Programs</div>}
              </div>
            </div>
          </div>
          {loading && loadingContent}
          {(tab === 1 && !loading && filterSpecial(courses || [])?.filter(co => !co?.enroll ).length === 0 ) && <div className="container-no-thearecontent-on">
            <h1>More On-Demand Certificate Programs Coming Soon</h1>
          </div>}
          {(tab === 2 && !loading && filterSpecial(courses || [])?.filter(co => !!co?.enroll && !co?.finish ).length === 0 ) && <div className="container-no-thearecontent-on">
            <h1>You have not yet enrolled in any On-Demand Certificate Programs.</h1>
          </div>}
          {(tab === 3 && !loading && filterSpecial(courses || [])?.filter(co => !!co?.finish ).length === 0 ) && <div className="container-no-thearecontent-on">
            <h1>You have not yet enrolled in any On-Demand Certificate Programs.</h1>
          </div>}
          <div className="container-list-ondemand">
            {tab === 1 && <>
              {filterSpecial(courses || [])?.filter(co => !co?.enroll ).map(e => <Card 
                data={e} 
                userProfile={userProfile}
                openModalContent={(dat) => openModalContent(dat)}
                clickCardOnDemand={async (dat) => {return await clickCardOnDemandPage(dat)}} 
              />)}
            </>}
            {tab === 2 && <>
              {filterSpecial(courses || [])?.filter(co => !!co?.enroll && !co?.finish ).map(e => <Card 
                data={e} 
                userProfile={userProfile}
                openModalContent={(dat) => openModalContent(dat)}
                clickCardOnDemand={async (dat) => {return await clickCardOnDemandPage(dat)}} 
              />)}
            </>}
            {tab === 3 && <>
              {filterSpecial(courses || [])?.filter(co => !!co?.finish ).map(e => <Card 
                data={e} 
                userProfile={userProfile}
                openModalContent={(dat) => openModalContent(dat)}
                clickCardOnDemand={async (dat) => {return await clickCardOnDemandPage(dat)}} 
              />)}
            </>}
          </div>
          <ModalEditInfo
            visible={(e) => setVisible(e)}
            finish={() => {
              setDataSelected({});
              getUrlLearnWorlds();
            }}
            dataSelected={dataSelected}
          />
        </div>
        <div className="course-container-on" style={dataPage ? {opacity:'1', zIndex:'2'} : {opacity:'0', zIndex:'1'}}>
          <div className="course-container-maxw" style={{maxWidth:'1000px'}}>
            <div className="container-backon" onClick={() => {setDataPage(false); history.push(INTERNAL_LINKS.ON_DEMAND_CERTIFICATEPROGRAMS);}}>
              <div className="container-backon__content-top">
                <div className="container-backon__content-top-back">
                  <img src={IconBack} alt="icon-back" />
                </div>
                <h4>Back to On-Demand Certificate Programs</h4>
              </div>
            </div>
            {/* Header Section */}
            <div className="header-section-on">
              <div className="icon-container">
                <span className="graduation-icon">🎓</span>
              </div>
              {/* <p className="enrollment-count">
                Join over 1,000 students already enrolled
              </p> */}
              <p className="subtitle">
                Join thousands of successful professionals who have already taken the first step 
                towards mastering Human Resources and transforming the future of work.
              </p>
              <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <CustomButton
                  className="special-card-button"
                  text={dataPage?.enroll ? 'Continue' : 'Enroll Now'}
                  type={dataPage?.enroll ? "secondary" : "primary"}
                  size="lg"
                  onClick={async () => {
                    setLoading3(true);
                    await clickCardOnDemand(dataPage);
                    setLoading3(false)
                  }}
                  loading={loading3}
                  style={{width:'300px'}}
                />
              </div>
              {/* <button 
                className="enroll-button" 
                onClick={() => clickCardOnDemand(dataPage)}
              >
                Enroll Now
              </button> */}
            </div>

            {/* Description Section */}
            <div className="content-card">
              <div className="overview-section">
                <span className="book-icon">📚</span>
                <div>
                  <h2 className="section-title">Course Overview</h2>
                  <div className="description-text"  dangerouslySetInnerHTML={{
                    __html:dataPage?.onDemand?.description
                  }}></div>
                </div>
              </div>
            </div>

            {/* Topics Section */}
            <div className="content-card">
              <h2 className="section-title">What You Will Learn</h2>
              <div className="topics-grid">
                {(dataPage?.onDemand?.topics || [])?.map((topic, index) => (
                  <div key={index} className="topic-item">
                    <span className="check-icon">✓</span>
                    <span>{topic}</span>
                  </div>
                ))}
              </div>
            </div>

            <div style={{height:'50px', width:'100%'}}></div>
          </div>
        </div>
      </div>
      {bulCompleteProfile && (
        <div className="complete-profile-ondemand">
          <ModalCompleteYourProfile
            userProfile={bulCompleteProfile ? userProfile : {}}
            get={getUser}
            setBulKnowRegister={() => {}}
            setBulCompleteProfile={setBulCompleteProfile}
            onClose={() => setBulCompleteProfile(false)}
          />
        </div>
      )}
    </> : diploma ? <Certificate diploma={diploma} userProfile={userProfile} back={'Back to On-Demand Certificate Programs'} /> : loadingContent}
  </div>);
};

const mapStateToProps = (state) => ({
  userProfile: homeSelector(state).userProfile,
});

const mapDispatchToProps = {
  getUser
};

export default connect(mapStateToProps, mapDispatchToProps)(OnDemandCertificateprograms);